var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModelReleaseFormWelcome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.676 24)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.319 135.864v-13.638s5.315 9.669 0 13.638Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.647 135.862-10.047-9.224s10.718 2.624 10.047 9.224Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.21 60.179 39.895 91.34a.816.816 0 0 1-1.115-.292L4.495 32.387a.816.816 0 0 1 .292-1.115L58.103.112a.816.816 0 0 1 1.114.291l34.286 58.662a.816.816 0 0 1-.293 1.114Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.21 60.179 39.895 91.34a.816.816 0 0 1-1.115-.292L4.495 32.387a.816.816 0 0 1 .292-1.115L58.103.112a.816.816 0 0 1 1.114.291l34.286 58.662a.816.816 0 0 1-.293 1.114ZM4.952 31.553a.49.49 0 0 0-.176.67l34.286 58.66a.49.49 0 0 0 .668.176l53.316-31.161a.49.49 0 0 0 .175-.669L58.936.568a.49.49 0 0 0-.669-.176L4.952 31.553Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.223 37.395 26 45.124a.816.816 0 0 1-1.115-.292l-7.728-13.224a.816.816 0 0 1 .292-1.114l13.223-7.729a.816.816 0 0 1 1.115.292l7.729 13.224a.816.816 0 0 1-.293 1.114Zm-21.61-6.62a.49.49 0 0 0-.175.669l7.729 13.223a.49.49 0 0 0 .668.176l13.224-7.729a.49.49 0 0 0 .175-.669l-7.728-13.223a.49.49 0 0 0-.67-.175l-13.222 7.728Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.37 41.233-13.223 7.729a.734.734 0 0 1-1.003-.263l-7.728-13.224a.734.734 0 0 1 .263-1.003l13.223-7.728a.734.734 0 0 1 1.003.263l7.729 13.223a.734.734 0 0 1-.263 1.003Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.287 31.26 26.93 55.433a.733.733 0 0 1-.74-1.266l41.359-24.173a.733.733 0 0 1 .74 1.266Zm-7.439 10.199-31.37 18.334a.733.733 0 0 1-.74-1.266l31.37-18.334a.733.733 0 1 1 .74 1.266Zm-2.074-26.153L40.486 25.994a.733.733 0 1 1-.74-1.266l18.288-10.689a.733.733 0 0 1 .74 1.267Zm-2.015 7.028-13.724 8.02a.733.733 0 0 1-.74-1.265l13.724-8.021a.733.733 0 0 1 .74 1.266Zm16.626 17.648L32.027 64.154a.733.733 0 0 1-.74-1.266l41.358-24.172a.733.733 0 0 1 .74 1.266ZM65.946 50.18l-31.37 18.335a.733.733 0 1 1-.74-1.266l31.37-18.335a.733.733 0 0 1 .74 1.266Zm12.537-1.476L37.124 72.876a.733.733 0 1 1-.74-1.266l41.359-24.172a.733.733 0 0 1 .74 1.266Zm2.548 4.361L39.673 77.237a.733.733 0 1 1-.74-1.266l41.358-24.172a.733.733 0 1 1 .74 1.266Z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.657 70.041a15.97 15.97 0 0 0 1.546-2.162c.408-.688.808-1.424.898-2.23a2.203 2.203 0 0 0-.66-1.883 1.55 1.55 0 0 0-1.819-.207 1.85 1.85 0 0 0-.928 1.651 2.443 2.443 0 0 0 1.044 1.85c1.222.886 3.131.84 4.434.166 1.468-.759 2.226-2.745 1.073-4.105-.24-.283-.639.033-.579.338a1.644 1.644 0 0 0 3.258-.402l-.518.303a3.957 3.957 0 0 0 3.936-.423 3.67 3.67 0 0 0 .737-.711c.254-.331.68-.545 1.025-.784l2.487-1.718c.366-.253.018-.855-.351-.6l-2.252 1.556c-.376.26-.753.515-1.126.778-.267.188-.431.49-.674.714a3.26 3.26 0 0 1-3.44.582.352.352 0 0 0-.52.303.952.952 0 0 1-1.89.224l-.578.338c.743.877.248 2.222-.609 2.81-.958.659-2.374.773-3.454.364a2.038 2.038 0 0 1-1.2-1.1 1.215 1.215 0 0 1 .275-1.391.872.872 0 0 1 1.212-.013c.363.37.518.898.413 1.406-.111.697-.496 1.34-.855 1.934a14.856 14.856 0 0 1-1.383 1.927c-.287.339.208.828.498.485Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.83 86.572c.06.062.115.128.164.198l7.702-.188.898-1.642 2.655 1.032-1.308 3.061a1.243 1.243 0 0 1-1.292.746l-8.701-1.051a1.63 1.63 0 1 1-.118-2.156Zm25.105 46.772h-2.532l-1.205-9.768h3.738z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.581 135.799h-8.165v-.104a3.178 3.178 0 0 1 3.178-3.178h4.987v3.282Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB7B7",
    d: "m75.941 133.288-2.328-.995 2.729-9.456 3.437 1.469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.571 135.799-7.509-3.208.04-.095a3.178 3.178 0 0 1 4.172-1.674l4.586 1.96-1.289 3.017Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB7B7",
    d: "m86.627 88.688-.183 2.968 5.352.572 5.601.6-1.649-4.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "m86.275 91.694-2.08-14.496 3.605-1.182 1.058-1.451 5.152.304.756 1.695 2.747 1.298-.422 7.84.308 6.557z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.966 87.81 81.3 86.341l.016-.065c.016-.066 1.576-6.586 1.783-7.634.216-1.091 1.004-1.393 1.038-1.406l.024-.009 1.451.442.637 5.007-1.283 5.132Zm-7.139 43.761-4.88-1 7.8-21.523 2.67-7.341s1.693-5.886 2.458-8.164l.461-3.056 10.928 1.21s3.052 4.482 2.125 11.788l.42 27.46-4.88.25L90.84 103.5l-7.174 15.183s-2.261 6.479-3.88 7.883l-1.96 5.005Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.882 92.716c.086-.002.172.003.257.014l5.098-5.776-.593-1.775 2.562-1.245 1.355 3.04c.225.505.09 1.098-.332 1.455l-6.686 5.666a1.63 1.63 0 1 1-1.661-1.38Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.83 87.517-2.127-5.003.83-3.484.893-1.13a.515.515 0 0 1 .414.004c.33.133.61.54.834 1.209l1.993 5.677-2.837 2.727ZM86.796 72.711V68.94a5.054 5.054 0 0 1 10.108 0v3.771a.68.68 0 0 1-.68.679h-8.749a.68.68 0 0 1-.679-.679Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFB7B7",
    cx: 90.812,
    cy: 69.597,
    r: 3.705
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6 69.241a4.002 4.002 0 0 1 3.998-3.997h.755a4.002 4.002 0 0 1 3.997 3.997v.076h-1.594l-.543-1.523-.109 1.523h-.824l-.274-.768-.055.768h-5.35v-.076Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.447 73.814a.669.669 0 0 1-.053-.71c.8-1.52 1.918-4.33.433-6.062l-.107-.125h4.312v6.475l-3.917.691a.676.676 0 0 1-.668-.27v.001Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F616A",
    d: "m40.14 131.21 2.289.818 4.244-8.438-3.378-1.207z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.764 133.22 1.06-2.965 4.507 1.61a3.054 3.054 0 0 1 1.845 3.9l-.033.093-7.38-2.638Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F616A",
    d: "M55.022 133.474h2.43l1.156-9.374h-3.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.402 132.68h4.786a3.05 3.05 0 0 1 3.05 3.05v.1h-7.836v-3.15Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.483 73.586 1.057-2.088s3.938.986 4.296 3.268l-5.353-1.18Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "m45.122 97.466 2.874 16.04-7.632 13.497 4.56 1.784 7.731-13.083.991-3.569.595 18.634 4.112-.125 1.885-17.4-3.024-16.174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.578 101.258c-4.222 0-6.903-.808-6.963-.82l-.097-.021 2.199-10.197.099-9.406c0-3.986 2.623-6.925 2.987-7.196.124-.49.458-.9.912-1.121.875-.397 1.945.08 1.99.1l3.21 1.203.014.045c.04.114 4.267 13.992 4.267 13.992s-.256 12.125-.346 12.523c0 0-5.925.898-8.272.898Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F616A",
    cx: 53.823,
    cy: 66.502,
    r: 4.338
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.2,
    d: "m48.986 81.583 7.59 10.588 1.12-4.944z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.78 88.787a1.862 1.862 0 0 1-2.795-.579l-6.532 1.046 1.415-3.133 5.986-.513a1.872 1.872 0 0 1 1.926 3.18Z",
    fill: "#9F616A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "m65.204 85.942 2.347-.23.65 3.274-2.953.053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.128 90.127-11.495-1.023-5.804-9.231-.018-.082a3.178 3.178 0 0 1 5.933-2.128l3.407 6.646 6.876 1.04 1.101 4.778Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.128 70.268 3.6.13c.22.008.816-2.361.894-2.852a1.341 1.341 0 0 1 1.399-1.085c.269.025.949-.478 1.65-1.075 1.331-1.131 1.262-3.257-.2-4.214-.04-.026-.08-.05-.118-.072-.923-.516-2.002-.69-3.06-.703-.958-.012-1.944.109-2.788.563-1.514.813-2.32 2.59-2.39 4.307-.071 1.717.48 3.396 1.104 4.997",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.385 136H.19a.189.189 0 1 1 0-.377h140.27c.104 0 .189.084.189.188 0 .105-.16.189-.264.189Z",
    fill: "#CBCBCB"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgModelReleaseFormWelcome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/model-release-form-welcome.94111761086fe8091b5aa61c542aad12.svg";